(function () {
  function webGridCarousel() {
    
    const wbswiper = document.querySelector('.web-carousel.swiper');
    const pagination = document.querySelector('.web-carousel.swiper .pagination');
    if (!wbswiper) {
      console.log('wbswiper failed')
      return
    }; // Safety check

    const gap = parseInt(wbswiper.getAttribute('data-gap'));

    new Swiper(wbswiper, {
      slidesPerView: 2,
       direction: 'horizontal',
      grid: {
        rows: 2,
        fill: 'row',
      },
      speed: 5000,
      loop: true,//循环
      autoplay: {
          delay: 0,//切换间隔
          stopOnLastSlide: false,//切换到最后一个时不停止自动播放
          disableOnInteraction: false,//触碰后不停止自动播放
      },
      spaceBetween: gap,
      pagination: {
        el: pagination,
        type : 'progressbar',
      },
      breakpoints: {
        '@0.75': {  //当屏幕宽高比大于等于0.75
          slidesPerView: 2,
          spaceBetween: gap,
        },
        '@1': {  //当屏幕宽高比大于等于1
          slidesPerView: 4,
          spaceBetween: gap,
        }
      }
    });
  }

  function initializeCarousel() {
    webGridCarousel();
  }

  document.addEventListener('DOMContentLoaded', initializeCarousel);
  window.addEventListener('load', initializeCarousel);
  document.addEventListener('shopify:section:load', initializeCarousel);
  window.addEventListener('resize', initializeCarousel);
})();
